module.exports = __webpack_public_path__ + "img/ngo.15da28b9.svg";